import { ArrowUpRight } from "lucide-react";
import { PARTNERS } from "../data/site";
import { Reveal } from "./Reveal";

export const Partners = () => (
  <div className="grid grid-cols-1 gap-6 md:grid-cols-2" data-testid="partners-list">
    {PARTNERS.map((p, i) => (
      <Reveal key={p.url} delay={i * 0.08}>
        <a
          href={p.url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`partner-link-${i}`}
          className="group flex h-full flex-col rounded-3xl border border-[#8A9B87]/25 bg-[#F7F4EE] p-8 transition-colors duration-300 hover:border-[#A9805B]/50"
        >
          <span className="flex items-start justify-between gap-4">
            <span className="flex items-center gap-4">
              <img
                src={p.logo}
                alt={`${p.name} logo`}
                width="64"
                height="64"
                loading="lazy"
                data-testid={`partner-logo-${i}`}
                className="h-16 w-16 shrink-0 rounded-full shadow-sm transition-transform duration-300 group-hover:scale-105"
              />
              <span className="text-xl font-light tracking-tight text-[#2E2E2C]">{p.name}</span>
            </span>
            <ArrowUpRight
              size={20}
              strokeWidth={1.6}
              className="mt-1 shrink-0 text-[#A9805B] transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
            />
          </span>
          <span className="mt-4 text-base text-[#2E2E2C]/70 leading-relaxed">{p.text}</span>
          <span className="mt-6 text-sm uppercase tracking-[0.16em] text-[#8A9B87]">
            {p.domain}
          </span>
        </a>
      </Reveal>
    ))}
  </div>
);
